import { Injectable } from '@angular/core';
import { ServiceConfig } from 'app/_services/service-config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ReportManagerService {
    private host = ServiceConfig.host;
    private BASE_URL = this.host + '/api/report-manager';
    private URL_BRAND = this.host + '/api/brand-manage';
    private httpHeaders = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    private httpParams = new HttpParams().set('token', JSON.parse(localStorage.getItem('currentSmmData')).token);

    constructor(private httpClient: HttpClient) {
    }

    getAll(filter): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/getListV2`, filter, { params: this.httpParams, headers: this.httpHeaders });
    }
    getBrands(): Observable<any> {
        return this.httpClient.post(`${this.URL_BRAND}/getActive`, {}, { params: this.httpParams, headers: this.httpHeaders });
    }
    createReport(body): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/createReport`, body, { params: this.httpParams, headers: this.httpHeaders });
    }
    getAllReport(): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/getAllReport`, {}, { params: this.httpParams, headers: this.httpHeaders });
    }
    getDetailReport(id): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/getDetailReport`, {id : id}, { params: this.httpParams, headers: this.httpHeaders });
    }
    deleteReportItem(id): Observable<any> {
        return this.httpClient.get(`${this.BASE_URL}/deleteBrandReport/${id}`,  { params: this.httpParams, headers: this.httpHeaders });
    }
    deletePartReport(id_report,id_part): Observable<any> {
        return this.httpClient.get(`${this.BASE_URL}/deletePartReport/${id_report}/${id_part}`,  { params: this.httpParams, headers: this.httpHeaders });
    }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/report-manager/report-manager.service.ts